@if(isActive) {<div class="overlay" (click)="overlayClicked()"></div>}
<table>
    @if(showHeaders) {
    <thead>
        @if(showSelectionBox) {
        <th class="selectbox">
            <input type="checkbox" [checked]="isAllSelected" (click)="selectAll()">
        </th>
        }
        @for(c of data.columns; track c; let ci = $index) {
        <th [ngClass]="c.getClass()" [class.sortable]="sortable && c.type !== 'actions' && c.type !== 'profile' && c.title"
            [class.uns]="ci !== this.sortColumn" [class.asc]="ci == this.sortColumn && this.sortDirection == 'asc'"
            [class.des]="ci == this.sortColumn && this.sortDirection == 'des'" (click)="onClick(ci)">{{c.title}}</th>
        }
    </thead>
    }
    <tbody [class.interactive]="interactive">
        @for(d of displayRows; track d; let di = $index) {
        <tr [class.activeRow]="di == activeActionRow" (click)="selectRow(di)">
            @if(di !== activeActionRow) {
            @if(showSelectionBox) {
            <td class="selectbox">
                @if(d.canSelect) {
                <input type="checkbox" [checked]="selectedRows.has(di)" (click)="selectIndividualRow($event, di)">
                } @else {
                &nbsp;
                }
            </td>
            }

            @for(c of d.cols; track c; let i = $index) {
            <td [ngClass]="[data.columns[i].align, data.columns[i].cellClass]" [title]="d.tooltips?.[i] || ''">
                <app-cf-table-cell [columnType]="data.columns[i].type" [column]="c" [options]="data.columns[i].options"
                    [profileSizePx]="profileSizePx" [profileBgColor]="profileBgColor" [profileTextColor]="profileTextColor" (click)="buttonClicked($event, d.pk)"></app-cf-table-cell>
            </td>
            }
            @if(data.rowActions) {
            <td class="rowActions cal">
                @for(a of data.rowActions; track a; let ri = $index; let last = $last) {
                <span class="rowActionItem" (click)="rowActionClicked(ri, di, d.pk)">{{a.text}}</span>@if(!last){<span class="rowActionSeparator">/</span>}
                }
            </td>
            }
            } @else {
            @if(showSelectionBox) {
            <td class="selectbox">&nbsp;</td>
            }
            @for (c of d.cols; track $index) {
            @if($index === activeActionStartColumn) {
            <td colSpan="{{activeActionRowSpan}}" (click)="clearRowAction(di)">
                @if(activeAction == 0) {
                <ng-content select="[firstAction]"></ng-content>
                }
                @if(activeAction == 1) {
                <ng-content select="[secondAction]"></ng-content>
                }
                @if(activeAction == 2) {
                <ng-content select="[thirdAction]"></ng-content>
                }
            </td>
            }@else {
            @if($index < activeActionStartColumn) { <td
                [ngClass]="[data.columns[$index].align, data.columns[$index].cellClass]">
                <app-cf-table-cell [columnType]="data.columns[$index].type" [column]="c"
                    [options]="data.columns[$index].options" [profileSizePx]="profileSizePx" [profileBgColor]="profileBgColor" [profileTextColor]="profileTextColor"
                    (click)="buttonClicked($event, d.pk)"></app-cf-table-cell>
                </td>
                }
                }
                }
                <td class="rowActions" (click)="clearRowAction(di)">
                    @if( activeActionStartColumn === data.columns.length - 1) {
                    @if(activeAction == 0) {
                    <ng-content select="[firstAction]"></ng-content>
                    }
                    @if(activeAction == 1) {
                    <ng-content select="[secAction]"></ng-content>
                    }
                    @if(activeAction == 2) {
                    <ng-content select="[thirdAction]"></ng-content>
                    }
                    }
                </td>
                }
        </tr>
        }
    </tbody>
</table>
@if(displayRows.length !== 0 && data.pages && data.pages.pageCount > 1) {
<div class="table-paginate">
    <button type="button" class="nav-btn" [disabled]="dp" (click)="previousPage()">
        <i class="fa-solid fa-chevron-left" [class.disabled]="dp"></i> Previous
    </button>
    <div class="page-numbers">
        @for(page of getPageNumbers(); track page) {
            @if(page === '...') {
                <span class="ellipsis">...</span>
            } @else {
                <button type="button" class="page-btn"
                    [class.active]="page === data.pages.currentPage"
                    (click)="goToPage(+page)">{{+page + 1}}</button>
            }
        }
    </div>
    <button type="button" class="nav-btn" [disabled]="dn" (click)="nextPage()">
        Next <i class="fa-solid fa-chevron-right" [class.disabled]="dn"></i>
    </button>
</div>
}